import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";

// Where Back leads when the page was opened directly (no earlier page in the app).
const parentPath = (pathname) => {
	const categoryGames = pathname.match(/^\/category\/([^/]+)\/games\/?$/);
	if (categoryGames) return `/category/${categoryGames[1]}`;
	const leaderboard = pathname.match(/^\/leaderboards\/([^/]+)\/?$/);
	if (leaderboard) return `/details/${leaderboard[1]}`;
	return "/";
};

// The Back button of inner pages (AK-253): the previous page, or a parent page
// when there is none.
const BackButton = ({ className = "" }) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const goBack = () => {
		if (window.history.state?.idx > 0) navigate(-1);
		else navigate(parentPath(pathname), { replace: true });
	};

	return (
		<button type="button" className={`backButton ${className}`} onClick={goBack} aria-label="Back" title="Back">
			<IoIosArrowBack aria-hidden="true" />
		</button>
	);
};

export default React.memo(BackButton);
